import React, { useState } from 'react'
import { validatePassword } from '../../../../Helpers/passwordValidations'
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth'
import PropTypes from 'prop-types'

import { Link } from 'react-router-dom'
import AuthForm from '../AuthForm'
import TextField from '../../../../Components/GeneralComponents/TextField'
import { ButtonOutline } from '../../../../Components/GeneralComponents/ButtonOutline/ButtonOutline'
import errorToast from '../../../../Components/Toasts/ErrorToast'
import { useAuth } from '../../../../Contexts/AuthContext'
import successToast from '../../../../Components/Toasts/SuccessToast'
import { app_sso } from '../../../../firebase'
import { useAPI } from '../../../../Contexts/APIContext'

const SignInForm = ({ email }) => {
  const [password, setPassword] = useState('')
  const [isLoginPending, setIsLoginPending] = useState(false)
  const { loginWithEmail } = useAuth()
  const { sendResetPassword } = useAPI()
  const auth = getAuth(app_sso)

  const handleChange = event => {
    const { value } = event.target
    setPassword(value)
  }

  const handleSendPasswordResetEmail = async () => {
    try {
      await sendResetPassword(email)
      successToast('Check the link to reset password at your mail inbox')
    } catch (error) {
      console.error(error)
      errorToast(error.message || 'Failed to send reset password email')
    }
  }

  const handleSubmit = async event => {
    event.preventDefault()

    const { error: passwordError } = validatePassword(password)
    if (passwordError) {
      errorToast(passwordError)
      return
    }

    try {
      setIsLoginPending(true)
      const { user } = await signInWithEmailAndPassword(auth, email, password)
      const accessToken = await user.getIdToken(true)
      await loginWithEmail(accessToken)
    } catch (error) {
      if (error.message.includes('(auth/invalid-login-credentials)'))
        errorToast('Invalid credentials')
    } finally {
      setIsLoginPending(false)
    }
  }

  return (
    <AuthForm title={'Login'} onSubmit={handleSubmit}>
      <fieldset>
        <TextField
          label={'Email'}
          placeholder={'Enter email'}
          onChange={handleChange}
          value={email}
          name={'email'}
          id="email"
          disabled
        />
        <Link to={'/'} id="signIn-link" className="help-link">
          Different email?
        </Link>
      </fieldset>
      <fieldset>
        <TextField
          label={'Password'}
          placeholder={'Enter password'}
          onChange={handleChange}
          value={password}
          name={'password'}
          type="password"
          id="password"
        />

        {/* NO URL !!!!! NO URL !!!!! NO URL !!!!! */}
        <div
          onClick={handleSendPasswordResetEmail}
          id="signIn-link"
          className="help-link"
        >
          Reset password?
        </div>
      </fieldset>
      <ButtonOutline
        type="submit"
        text="log in"
        color="pink"
        className="login-button"
        disable={!password || isLoginPending}
      />
    </AuthForm>
  )
}

SignInForm.propTypes = {
  email: PropTypes.string,
}
export default SignInForm
